import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface EmailLogResponseDTO {
  id: number;
  recipientEmail: string;
  recipientName?: string;
  emailType: string;
  subject: string;
  sentAt: Date;
  isSuccess: boolean;
  errorMessage?: string;
  mailjetStatusCode?: number;
  paymentLinkId?: number;
  templateId?: number;
}

export interface EmailLogRequestDTO {
  page?: number;
  pageSize?: number;
  recipientEmail?: string;
  emailType?: number;
  dateFrom?: Date;
  dateTo?: Date;
  isSuccess?: boolean;
  paymentLinkId?: number;
  orderBy?: string;
  orderDirection?: string;
}

export interface PaginatedEmailLogResponse {
  data: EmailLogResponseDTO[];
  totalRecords: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

@Injectable({
  providedIn: 'root'
})
export class EmailLogService {

  private readonly apiUrl = `${environment.apiUrl}/EmailLog`;

  constructor(private http: HttpClient) { }

  searchEmailLogs(request: EmailLogRequestDTO): Observable<PaginatedEmailLogResponse> {
    return this.http.post<PaginatedEmailLogResponse>(`${this.apiUrl}/search`, request);
  }

  getEmailLogById(id: number): Observable<EmailLogResponseDTO> {
    return this.http.get<EmailLogResponseDTO>(`${this.apiUrl}/${id}`);
  }

  getEmailTypeLabel(type: string): string {
    switch (type) {
      case 'ParticipantPaymentLink': return 'Link de Pago - Participante';
      case 'CompanyPaymentLink': return 'Link de Pago - Empresa';
      case 'PaymentReminder': return 'Recordatorio de Pago';
      case 'Generic': return 'Genérico';
      default: return type;
    }
  }

  getEmailTypeClass(type: string): string {
    switch (type) {
      case 'ParticipantPaymentLink': return 'text-blue-700 bg-blue-100';
      case 'CompanyPaymentLink': return 'text-purple-700 bg-purple-100';
      case 'PaymentReminder': return 'text-orange-700 bg-orange-100';
      case 'Generic': return 'text-gray-700 bg-gray-100';
      default: return 'text-gray-700 bg-gray-100';
    }
  }

  getSuccessClass(isSuccess: boolean): string {
    return isSuccess ? 'text-green-700 bg-green-100' : 'text-red-700 bg-red-100';
  }

  formatDateTime(date: Date | string): string {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  truncateText(text: string | undefined, maxLength: number = 100): string {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }
}
